import ES from "./es"
import EN from "./en"

export const getTranslation =
    (key, lang) => lang===1 ? EN[key] : ES[key];

export const langs = ['es', 'en'];